import type { AxiosError } from 'axios';

/** User-facing message from a failed API call (axios or Error). */
export function extractApiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as AxiosError<{ message?: string }>).response?.data;
    const msg = data?.message?.trim();
    if (msg) return msg;
  }
  if (err instanceof Error) {
    const msg = err.message.trim();
    if (msg && !/^request failed with status code \d+$/i.test(msg)) return msg;
  }
  return fallback;
}
